<script setup lang="ts">
useHead({
  titleTemplate: (title) => title ? `${title} | RojaTac | Zemní a výkopové práce` : "RojaTac | Zemní a výkopové práce"
});
</script>

<template>
  <NuxtLayout>
    <NuxtPage />
  </NuxtLayout>
</template>